const DEFAULT_FALLBACK = '暂无详细发布内容'

function normalizeReleaseContent(value) {
  if (value === null || value === undefined) return ''
  return String(value)
    .replace(/已\uFFFD+问题/g, '已知问题')
    .replace(/\uFFFD+/g, '')
    .replace(/\u00a0/g, ' ')
    .trim()
}

function containsHtml(value) {
  return /<\/?[a-z][\s\S]*>/i.test(value)
}

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

function formatReleaseContent(value, fallback = DEFAULT_FALLBACK) {
  const content = normalizeReleaseContent(value)
  if (!content) return `<p>${escapeHtml(fallback)}</p>`
  if (containsHtml(content)) return content

  return `<p>${escapeHtml(content).replace(/\n/g, '<br>')}</p>`
}

function hasReleaseContent(value) {
  return normalizeReleaseContent(value).length > 0
}

module.exports = {
  DEFAULT_FALLBACK,
  normalizeReleaseContent,
  formatReleaseContent,
  hasReleaseContent
}
